@if (lahetysdata | async) {
  <div>
    <div class="blue-background">
      <div style="margin-left: auto; margin-right: auto">
        <div class="ylapalkki valkoinen">
          <button class="sulje" mat-button (click)="peruutaLahettaminen()" type="button" class="valkoinen">
            <i style="font-size: 60px; width: 60px; height: 60px; line-height: 60px; display: inline-block" class="icon ion-md-arrow-back"></i>
          </button>
          <div class="dropparit-container" style="width: 100%">
            <div class="dropparit">
              <button (click)="vaihdaValilehti(0)" mat-button style="text-align: center; margin: 5px; padding: 5px; border-radius: 10px; font-weight: 100; font-size: 16px; min-width: 84.5px" [class.selectedmenu]="(aktiivinenValilehti | async) === 0">
                <i class="icon ion-ios-at-outline" style="font-size: 43px; height: 37px; display: inline-block; line-height: 37px"></i>
                <br />
                {{ 'lasku.sposti-dialog.laheta-lasku-spostilla' | translate | async }}
              </button>
              <button (click)="vaihdaValilehti(1)" mat-button style="text-align: center; margin: 5px; padding: 5px; border-radius: 10px; font-weight: 100; font-size: 16px; min-width: 84.5px" [class.selectedmenu]="(aktiivinenValilehti | async) === 1">
                <i class="icon ion-ios-flash-outline" style="font-size: 43px; height: 37px; display: inline-block; line-height: 37px"></i>
                <br />
                {{ 'lasku.sposti-dialog.verkkolasku.laheta-verkkolaskuna' | translate | async }}
              </button>
              <button (click)="vaihdaValilehti(2)" mat-button style="text-align: center; margin: 5px; padding: 5px; border-radius: 10px; font-weight: 100; font-size: 16px; min-width: 84.5px" [class.selectedmenu]="(aktiivinenValilehti | async) === 2">
                <i class="icon ion-ios-person-outline" style="font-size: 43px; height: 37px; display: inline-block; line-height: 37px"></i>
                <br />
                {{ 'lasku.sposti-dialog.itse.laheta' | translate | async }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-laheta-component [data]="lahetysdata | async" [aktiivinenValilehti]="aktiivinenValilehti | async" (laskuLahetettiin)="kasitteleLahetys($event)" (laskuAjastettiin)="salliPoistuminenAjastuksenJalkeen()"></app-laheta-component>
  </div>
} @else {
  <form novalidate autocomplete="kirjanpitoaineistoarkki" class="lasku-sivu">
    <div class="sivun-otsake">
      <button class="takaisin light-blue-text" mat-icon-button (click)="peruuta()" type="button" [attr.aria-label]="'yleiset.peruuta' | translate | async">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h1 class="light-blue-text">{{ sivunOtsikonAvain | translate | async }}</h1>
      <span class="kasvata"></span>
      @if (naytaLaskunTyyppiObservable | async) {
        <mat-button-toggle-group [formField]="lomake.laskunLuonne" class="laskun-luonne" [hideSingleSelectionIndicator]="true" [attr.aria-label]="'lasku.laskun-luonne' | translate | async">
          <mat-button-toggle value="lasku">{{ 'laskuntyyppi.tav' | translate | async }}</mat-button-toggle>
          <mat-button-toggle value="ennakkolasku">{{ 'laskuntyyppi.ennakko' | translate | async }}</mat-button-toggle>
          <mat-button-toggle value="kateislasku">{{ 'laskuntyyppi.kateinen' | translate | async }}</mat-button-toggle>
        </mat-button-toggle-group>
      }
    </div>

    @if (juurilasku.avain !== kasiteltava.avain && kasiteltava.nrotyyppi === 'h') {
      <div class="huomautus">{{ 'lasku.hyvitys-info-teksti' | translate | async }}</div>
    }
    @if (juurilasku.avain !== kasiteltava.avain && kasiteltava.nrotyyppi !== 'h') {
      <div class="huomautus">{{ 'lasku.muokkaus-info-teksti' | translate | async }}</div>
    }

    <div class="lasku-asettelu">
      <div class="lomake">
        <section class="osio">
          <h2 class="osion-otsikko light-blue-text">{{ 'lasku.nimi' | translate | async }}</h2>
          <app-lasku-asiakas #asiakkaanTiedot [parent]="lomake" [laskunTyyppiObservable]="laskunTyyppiObservable" [laskuObservable]="laskuObservable" (asiakasMuuttui)="paivitaValittuAsiakas($event)" (uusiAsiakas)="avaaAsiakasDialogi($event)" (muokkaa)="avaaAsiakasDialogi()" [paivitaValidaatiot]="paivitaValidaatiot">
            <div class="kortin-rivit">
              @if (!muokkaaLaskunTietoja) {
                <div class="kortin-rivi">
                  <span class="rivin-otsikko">{{ 'lasku.myyntilaji' | translate | async }}</span>
                  <span [class.muutettu]="myyntilajiMuutettu">{{ 'myynnin-laji.' + lomake.tyyppi().value()?.avain | translate | async }}</span>
                </div>
                @if (lomake.tyyppi().value()?.avain === 'kuleur') {
                  <app-eu-kuluttajamyynti-huomautus class="eu-kuluttajamyynti-huomautus"></app-eu-kuluttajamyynti-huomautus>
                }
                <div class="kortin-rivi">
                  <span class="rivin-otsikko">{{ 'lasku.valuutta' | translate | async }}</span>
                  <span [class.muutettu]="valuuttaMuutettu">{{ lomake.valuutta().value() }}</span>
                </div>
                <div class="kortin-rivi">
                  <span class="rivin-otsikko">{{ 'lasku.maksuehto' | translate | async }}</span>
                  @if (onKateislasku) {
                    <span class="kateislasku-maksettu haivyta-sisaan">{{ 'lasku.kateislasku-maksettu' | translate | async }}</span>
                  } @else {
                    <span class="haivyta-sisaan">{{ 'lasku.asiakas-dialog.maksuehto-teksti' | translate: { paivia: lomake.maksuaikaa().value(), erapaiva: (lomake.erapaiva().value() | ldate | async) } | async }}</span>
                  }
                </div>
                @if (laskunTiedotMuutettu) {
                  <div class="huomautus-oranssi">{{ 'lasku.muutetut-tiedot-vain-talle-laskulle' | translate | async }}</div>
                }
                <button type="button" class="kortin-linkki" (click)="aloitaLaskunTietojenMuokkaus()">
                  <mat-icon>edit</mat-icon>
                  {{ (laskunTiedotMuutettu ? 'lasku.muokkaa-taman-laskun-tietoja' : 'lasku.muuta-tietoja-talle-laskulle') | translate | async }}
                </button>
              } @else {
                <div>
                  <div class="kortin-rivi muokkaus">
                    <span class="rivin-otsikko" [class.muutettu]="myyntilajiMuutettu">{{ 'lasku.myyntilaji' | translate | async }}</span>
                    <mat-form-field subscriptSizing="dynamic">
                      <mat-select [compareWith]="vertaaTyyppia" [formField]="laskunTiedotLomake.tyyppi" [aria-label]="'lasku.myyntilaji' | translate | async">
                        @for (tyyppi of tyypitObservable | async; track tyyppi.avain) {
                          <mat-option [value]="tyyppi">{{ 'myynnin-laji.' + tyyppi.avain | translate | async }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  @if (laskunTiedotLomake.tyyppi().value()?.avain === 'kuleur') {
                    <app-eu-kuluttajamyynti-huomautus class="eu-kuluttajamyynti-huomautus muokkaus"></app-eu-kuluttajamyynti-huomautus>
                  }
                  <div class="kortin-rivi muokkaus">
                    <span class="rivin-otsikko" [class.muutettu]="valuuttaMuutettu">{{ 'lasku.valuutta' | translate | async }}</span>
                    <mat-form-field subscriptSizing="dynamic">
                      <mat-select [formField]="laskunTiedotLomake.valuutta" [aria-label]="'lasku.valuutta' | translate | async">
                        @for (valuutta of valuutatObservable | async; track valuutta.koodi) {
                          <mat-option [value]="valuutta.koodi">{{ valuutta.koodi }} ({{ 'valuutta.' + valuutta.koodi | translate | async }})</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  @if (!onKateislasku) {
                    <div class="kortin-rivi muokkaus">
                      <span class="rivin-otsikko">{{ 'lasku.maksuehto' | translate | async }}</span>
                      @if (laskunTiedotLomake.maksuaikaValinta().value() === 'muu') {
                        <mat-form-field subscriptSizing="dynamic">
                          <input type="number" step="1" [formField]="laskunTiedotLomake.maksuaikaa" matInput [attr.aria-label]="'lasku.maksuehto' | translate | async" />
                          <span matSuffix>{{ 'lasku.pv-netto' | translate | async }}</span>
                        </mat-form-field>
                      } @else {
                        <mat-form-field subscriptSizing="dynamic">
                          <mat-select [formField]="laskunTiedotLomake.maksuaikaValinta" [aria-label]="'lasku.maksuehto' | translate | async">
                            @for (paivia of maksuaikaVaihtoehdot(); track paivia) {
                              <mat-option [value]="paivia">{{ paivia }} {{ 'lasku.pv-netto' | translate | async }}</mat-option>
                            }
                            <mat-option value="muu">{{ 'lasku.muu' | translate | async }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      }
                    </div>
                  }
                  <div class="huomautus-oranssi">{{ 'lasku.muutetut-tiedot-vain-talle-laskulle' | translate | async }}</div>
                  <div class="kortin-napit">
                    <button class="secondarybutton" mat-button (click)="peruutaLaskunTietojenMuokkaus()" type="button">{{ 'yleiset.peruuta' | translate | async }}</button>
                    <button class="primarybutton" mat-button (click)="kaytaLaskunTiedotTalleLaskulle()" type="button">{{ 'lasku.kayta-talle-laskulle' | translate | async }}</button>
                  </div>
                </div>
              }
            </div>
          </app-lasku-asiakas>
        </section>

        <section class="osio">
          <div class="laskun-tiedot">
            <app-lasku-muut-tiedot [parent]="lomake" [laskuObservable]="laskuObservable" [paivitaValidaatiot]="paivitaValidaatiot" [naytaViivastuskorko]="naytaViivastuskorkoObservable | async" [kateislasku]="onKateislasku" [naytaVainViitteenneJaLisatiedot]="true"></app-lasku-muut-tiedot>
          </div>
        </section>

        <section class="osio">
          <div class="osion-otsake">
            <h2 class="osion-otsikko light-blue-text">{{ 'lasku.laskurivit' | translate | async }}</h2>
            <span class="kasvata"></span>
            <div class="toimituspaiva">
              <span class="toimituspaiva-otsikko">{{ 'lasku.toimituspvm' | translate | async }}</span>
              <button type="button" class="toimituspaiva-arvo" (click)="toimituspaivaPicker.open()">
                <input [matDatepicker]="toimituspaivaPicker" [formField]="lomake.toimituspvm" tabindex="-1" aria-hidden="true" />
                <span>{{ (lomake.toimituspvm().value() | ldate | async) || '–' }}</span>
                <mat-icon>expand_more</mat-icon>
              </button>
              <mat-datepicker #toimituspaivaPicker></mat-datepicker>
            </div>
          </div>
          <app-lasku-rivit
            [parent]="lomake"
            [laskuObservable]="laskuObservable"
            [laskunLiitetiedostotObservable]="laskunLiitetiedostotObservable"
            [laskunVastaanottajanMaaObservable]="laskunVastaanottajanMaaObservable"
            [laskunTyyppiObservable]="laskunTyyppiObservable"
            [laskunTuotteetObservable]="laskunTuotteetObservable"
            [paivitaValidaatiot]="paivitaValidaatiot"
            [verottomanMyynninOletusperuste]="asetukset?.verottomanMyynninOletusperuste"
          ></app-lasku-rivit>
          <div class="yhteensa">
            <span>{{ 'lasku.summat.veroton' | translate | async }}</span>
            <span class="summa">{{ laskunSummat().alvitonSumma | lmoney: kasiteltava?.valuutta | async }}</span>
            @for (osa of laskunSummat().alvErittely; track osa.prosentti) {
              <span>{{ 'lasku.summat.alv' | translate | async }} {{ osa.prosentti | ldecimal: 2 | async }} %</span>
              <span class="summa">{{ osa.summa | lmoney: kasiteltava?.valuutta | async }}</span>
            } @empty {
              <span>{{ 'lasku.summat.alv' | translate | async }}</span>
              <span class="summa">{{ laskunSummat().alvSumma | lmoney: kasiteltava?.valuutta | async }}</span>
            }
            @if (aiemminMaksettu) {
              <span>{{ 'lasku.yhteensa-verollinen' | translate | async }}</span>
              <span class="summa">{{ laskunSummat().yhteensaSumma | lmoney: kasiteltava?.valuutta | async }}</span>
              <span>{{ 'lasku.aiemmin-maksettu-tuote' | translate | async }}</span>
              <span class="summa">{{ aiemminMaksettu | lmoney: kasiteltava?.valuutta | async }}</span>
            }
            <span class="iso light-blue-text">{{ (aiemminMaksettu ? 'pdf-perinteinen.maksettava-yhteensa' : 'lasku.summat.yhteensa') | translate | async }}</span>
            <span class="iso summa light-blue-text">{{ laskunSummat().yhteensaSumma + aiemminMaksettu | lmoney: kasiteltava?.valuutta | async }}</span>
          </div>
          @if (rekisterinMuutokset().length) {
            <div class="rt-sum">
              <button type="button" class="rt-sum-h" [class.open]="rekisterinMuutoksetAuki" [attr.aria-expanded]="rekisterinMuutoksetAuki" (click)="rekisterinMuutoksetAuki = !rekisterinMuutoksetAuki">
                <mat-icon>inventory_2</mat-icon>
                <span>{{ rekisterinMuutostenOtsikko() }}</span>
                <mat-icon class="ced">expand_more</mat-icon>
              </button>
              @if (rekisterinMuutoksetAuki) {
                <div class="rt-sum-l">
                  @for (muutos of rekisterinMuutokset(); track muutos.rivi) {
                    <div>
                      <app-kuutio-ikoni [tila]="muutos.onUusiTuote ? kuutionTilat.VAPAA_TALLENNETAAN : kuutionTilat.REKISTERI_PAIVITETAAN" [koko]="18"></app-kuutio-ikoni>
                      @if (muutos.onUusiTuote) {
                        <span class="rt-sum-teksti">
                          <b>{{ muutos.nimi }}</b> {{ 'lasku.rekisteri.tallennetaan-uutena' | translate | async }} · {{ muutos.hinta | lmoney: kasiteltava?.valuutta | async }} / {{ muutos.yksikko }}, {{ 'lasku.rekisteri.alv' | translate | async }} {{ muutos.alv?.prosentti | ldecimal: 2 | async }} %
                        </span>
                      } @else {
                        <span class="rt-sum-teksti">
                          <b>{{ muutos.nimi }}</b> ·
                          <span class="rt-sum-osat">
                            @if (muutos.vanhaHinta !== undefined) {
                              <span>{{ 'lasku.rekisteri.hinta' | translate | async }} {{ muutos.vanhaHinta | lmoney: kasiteltava?.valuutta | async }} → {{ muutos.hinta | lmoney: kasiteltava?.valuutta | async }}</span>
                            }
                            @if (muutos.vanhaYksikko !== undefined) {
                              <span>{{ 'lasku.rekisteri.yksikko' | translate | async }} {{ muutos.vanhaYksikko }} → {{ muutos.yksikko }}</span>
                            }
                            @if (muutos.vanhaAlvTunniste !== undefined) {
                              <span>{{ 'lasku.rekisteri.alv' | translate | async }} {{ 'alv.' + muutos.vanhaAlvTunniste | translate | async }} → {{ muutos.alv?.prosentti | ldecimal: 2 | async }} %</span>
                            }
                          </span>
                        </span>
                      }
                      <button type="button" class="rt-sum-peru" (click)="peruRekisterinMuutos(muutos)">{{ 'lasku.rekisteri.peru' | translate | async }}</button>
                    </div>
                  }
                  <div class="rt-sum-vihje">{{ 'lasku.rekisteri.paivittyy-lahetettaessa' | translate | async }}</div>
                </div>
              }
            </div>
          }
          @if (asetuksissaOnOletustietojaVirhe) {
            <div class="red-text virhe">{{ 'lasku.validation.asetukset.oletuksia-print' | translate | async }}</div>
          }
          @if (laskunSummat().hyvitysPositiivinenVirhe) {
            <div class="red-text virhe">{{ 'lasku.validation.hyvitys.ei-voi-olla-positiivinen' | translate | async }}</div>
          }
        </section>
      </div>

      <div class="esikatselu" [class.vaihtuu]="laskunEsikatseluVaihtuu()">
        <div class="osion-otsikko light-blue-text">{{ 'lasku.esikatselu.otsikko' | translate | async }}</div>
        <lasku-pdf-esikatselu-perinteinen [tiedot]="esikatselutiedot | async" [laskunLahetysPiilotaProjekti]="true"></lasku-pdf-esikatselu-perinteinen>
      </div>
    </div>

    <div class="toimintopalkki">
      <div class="palkin-summa">
        <span class="vihje">{{ (aiemminMaksettu ? 'pdf-perinteinen.maksettava-yhteensa' : 'lasku.summat.yhteensa') | translate | async }}</span>
        <b class="light-blue-text">{{ laskunSummat().yhteensaSumma + aiemminMaksettu | lmoney: kasiteltava?.valuutta | async }}</b>
        <span class="vihje">{{ (rivienMaara() === 1 ? 'lasku.summat.rivi' : 'lasku.summat.rivia') | translate: { maara: rivienMaara() } | async }}</span>
      </div>
      <span class="kasvata"></span>
      @if (!hyvitys && juurilasku.avain === kasiteltava.avain) {
        <button class="secondarybutton" mat-button (click)="save()" type="button">{{ 'lasku.tallenna-luonnos' | translate | async }}</button>
      }
      <button class="primarybutton" mat-button (click)="saveAndSendEmail()" type="button">{{ 'lasku.jatka-lahettamaan' | translate | async }}</button>
    </div>
  </form>
}
